import React from 'react'
import { PageLoader } from '../ui/States'

/** Page-level loading state (kept for existing screens). */
const Loading = ({ label = 'Please wait…', fullScreen = false }) => <PageLoader label={label} fullScreen={fullScreen} />

export default Loading
